import { useMemo } from 'react';
import cm from 'classnames';

import { useAppSelector } from 'store/store-hooks';
import { Path, useLocation } from 'components/_hooks/use-router';
import { selectLinkedGroup } from 'components/app/editor/_mediator/editor-clips/editor-clips-linking.helper';
import { Clip } from 'components/app/editor/_mediator/editor.slice';
import styles from './_track-clip.module.scss';

interface Props {
  clipData: Clip;
  className?: string;
}

export const ClipLinking = ({ clipData, className }: Props) => {
  const fcLinkedClips = useAppSelector((state) => state.fc__data.fcLinkedClips);
  const linkedClips = useAppSelector((state) => state.editor.linkedClips);
  const { path } = useLocation();

  const linkedGroup = useMemo(() => {
    if (!clipData.clipGroupId) return;
    const linkedGroup = selectLinkedGroup(clipData.clipGroupId, path === Path.finalcuts ? fcLinkedClips : linkedClips);
    return linkedGroup.length ? linkedGroup : undefined;
  }, [path, linkedClips, fcLinkedClips]);

  if (!clipData.clipGroupId || !linkedGroup) return null;
  return (
    <div
      className={cm(styles.Linking, className, {
        [styles['Linking--first']]: linkedGroup[0] === clipData.clipId,
        [styles['Linking--last']]: linkedGroup[linkedGroup.length - 1] === clipData.clipId,
      })}
    >
      <div className={styles.Linking__left} />
      <div className={styles.Linking__circle} />
      <div className={styles.Linking__right} />
    </div>
  );
};
